import { IStateAppProvider } from "../../interfaces";
import {
  SET_ALERT,
  SET_ANSWERS,
  SET_CIDADES,
  SET_DISABLED_BUTTONS,
  SET_ESTADOS,
  SET_IS_VISIBLE_PARY_CONFETTI,
  SET_LOADING,
  SET_QUESTIONS,
  SET_STEP,
  SET_VOUCHER,
  SET_CONFIG,
  SET_BAIRROS
} from "./types";

export const INITIAL_STATE: IStateAppProvider = {
  config: {
    partnerId: 133,
    steps: [
      {
        label: 'Bem Vinda',
      },
      {
        label: 'Planejamento n²',
        description: "Como parte do processo para receber seu crédito, devemos planejar como vamos usar esse dinheiro.\n\nPreencha os campos abaixo para nossos Orientadores Financeiros ajudarem você no planejamento do seu negócio.",
      },
      {
        label: 'Cupom',
      }
    ],
    assets: {
      slogan: {
        src: "assets/img/slogan.png",
        name: "slogan"
      },
      logos: null,
      cards: [
        {
          src: 'assets/img/card1.png',
          name: 'card1',
          width: '100%',
        }
      ],
      poweredby: "assets/img/poweredby.png",
      appstore: "assets/img/appstore.jpeg",
      googleplay: "assets/img/googleplay.png",
      qrcode: "assets/img/qrcode.png",
    },
  },
  questions: [],
  answers: [],
  loading: '',
  voucher: '',
  estados: {list: [], loading: false},
  cidades: {list: [], loading: false},
  bairros: {list: [], loading: false},
  alertValues: null,
  activeStep: 0,
  disabledButtons: false,
  isVisiblePartyConfetti: false
}

export const reducer = (
  state: IStateAppProvider, 
  action: {
    payload?: IStateAppProvider,
    type: string
  }): IStateAppProvider => {
  switch (action.type) {
    case SET_QUESTIONS:
      return {
        ...state,
        questions: action?.payload?.questions
      };

    case SET_ANSWERS:
      return {
        ...state,
        answers: action?.payload?.answers
      };

    case SET_LOADING:
      return {
        ...state,
        loading: action?.payload?.loading
      };

    case SET_VOUCHER:
      return {
        ...state,
        voucher: action?.payload?.voucher
      };

    case SET_ESTADOS:
      return {
        ...state,
        estados: action?.payload?.estados
      };

    case SET_CIDADES:
      return {
        ...state,
        cidades: action?.payload?.cidades
      };

    case SET_BAIRROS:
      return {
        ...state,
        bairros: action?.payload?.bairros
      };

    case SET_ALERT:
      return {
        ...state,
        alertValues: action?.payload?.alertValues
      };

    case SET_STEP:
      return {
        ...state,
        activeStep: action?.payload?.activeStep
      };

    case SET_DISABLED_BUTTONS:
      return {
        ...state,
        disabledButtons: action?.payload?.disabledButtons
      };

    case SET_IS_VISIBLE_PARY_CONFETTI:
      return {
        ...state,
        isVisiblePartyConfetti: action?.payload?.isVisiblePartyConfetti
      };

    case SET_CONFIG:
      return {
        ...state,
        config: action?.payload?.config
      };

    default:
     return {...state};
  }
};